import { useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { Scissors } from "lucide-react";
import { fetchAlertes } from "@/lib/dossiers";
import { fmtEur } from "@/lib/kpis";

const TICK = { fontSize: 10, fill: "#64748b" };

/** Mini courbe discrète Dettes fournisseurs (40) vs Créances clients (41) par exercice — masquée si < 2 exercices. */
export default function CiseauxMiniChart({ dossierId }) {
    const [rows, setRows] = useState(null);
    useEffect(() => {
        let cancelled = false;
        fetchAlertes(dossierId).then((a) => {
            if (cancelled) return;
            const entite = (a?.ciseaux || []).filter((c) => !c.est_holding);
            const byYear = {};
            entite.forEach((c) => c.rows.forEach((r) => { byYear[r.exercice] = { exercice: r.exercice, fournisseurs: r.fournisseurs, clients: r.clients }; }));
            setRows(Object.values(byYear).sort((x, y) => String(x.exercice).localeCompare(String(y.exercice))));
        }).catch(() => setRows([]));
        return () => { cancelled = true; };
    }, [dossierId]);
    if (!rows || rows.length < 2) return null;
    const last = rows[rows.length - 1], prev = rows[rows.length - 2];
    const alert = last.fournisseurs > prev.fournisseurs * 1.1 && last.clients <= prev.clients * 1.02;
    return (
        <div data-testid="ciseaux-mini-chart" className={`rounded-xl border px-4 py-3 shadow-sm ${alert ? "border-amber-300 bg-amber-50" : "border-slate-200 bg-white"}`}>
            <div className="flex items-center justify-between gap-2">
                <p className="text-[11px] uppercase tracking-[0.14em] text-muted-foreground flex items-center gap-1.5"><Scissors className="h-3.5 w-3.5" /> Effet ciseaux · fournisseurs (40) vs clients (41)</p>
                {alert && <span data-testid="ciseaux-alert-badge" className="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-800">Tension détectée</span>}
            </div>
            <ResponsiveContainer width="100%" height={90}>
                <LineChart data={rows} margin={{ top: 8, right: 8, bottom: 0, left: 0 }}>
                    <XAxis dataKey="exercice" tick={TICK} axisLine={false} tickLine={false} />
                    <YAxis hide />
                    <Tooltip formatter={(v, name) => [fmtEur(v), name === "fournisseurs" ? "Dettes fournisseurs" : "Créances clients"]} labelFormatter={(l) => `Exercice ${l}`} contentStyle={{ fontSize: 11 }} />
                    <Line type="monotone" dataKey="fournisseurs" stroke="#B91C1C" strokeWidth={2} dot={{ r: 2.5 }} isAnimationActive={false} />
                    <Line type="monotone" dataKey="clients" stroke="#047857" strokeWidth={2} dot={{ r: 2.5 }} isAnimationActive={false} />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
